var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueMultiselect,_vm._b({staticClass:"multiselect-mid pl-2",attrs:{"value":_vm.modelValue,"options":_vm.options,"select-label":"","deselect-label":"","label":"name","track-by":"name"},on:{"input":_setup.onInput}},'VueMultiselect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }